<!-- PatientHeaderToolTipItem.vue -->
<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps<{
        topBorder?: boolean
    }>();

    const rowStyle = computed(() =>{
            return {
                "border-top": props.topBorder ? "solid 1px grey" : undefined,
            };
    });

    const labelClass = computed(() => props.topBorder ? "label label-border-top" : "label");
    const valueClass = computed(() => props.topBorder ? "value value-border-top" : "value");
</script>

<style scoped>
    @import url('../../../../css/toolTipGrid.css');
</style>

<template>

    <div :class="labelClass">
        <slot name="title" />
    </div>

    <div :class="valueClass">
        <slot />
    </div>

    <!-- <tr :style="rowStyle">
        <td style="color:gray">
            <slot name="title"></slot>
        </td>
        <td style="color:#204d89">
            <slot></slot>
        </td>
    </tr> -->
</template>